// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import EventDetailSvg from '@rsuite/icon-font/lib/time/EventDetail';
var EventDetail = createSvgIcon({
  as: EventDetailSvg,
  ariaLabel: 'event detail',
  category: 'time',
  displayName: 'EventDetail'
});
export default EventDetail;